import React from "react";

/**
 * Pager for server-paginated entity lists. Used under both the card and the table view
 * so the two behave identically (the table's own client-side pager is turned off).
 *
 * "13–24 of 57" plus first / previous / next / last. Hidden when everything fits on
 * one page.
 */
export default function Paginator({ page, pageCount, pageSize, total, onChange, disabled }) {
    if (total <= pageSize) return null;

    const from = (page - 1) * pageSize + 1;
    const to = Math.min(page * pageSize, total);
    const go = (p) => {
        if (p >= 1 && p <= pageCount && p !== page) onChange(p);
    };

    const btn = (label, icon, target, isDisabled) => (
        <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            aria-label={label}
            title={label}
            disabled={disabled || isDisabled}
            onClick={() => go(target)}
        >
            <i className={`fa ${icon}`} />
        </button>
    );

    return (
        <div className="d-flex align-items-center justify-content-end gap-3 py-3 small text-muted">
            <span>
                {from}–{to} of {total}
            </span>
            <div className="d-flex gap-1">
                {btn("First page", "fa-angle-double-left", 1, page <= 1)}
                {btn("Previous page", "fa-angle-left", page - 1, page <= 1)}
                <span className="px-2 align-self-center">
                    Page {page} of {pageCount}
                </span>
                {btn("Next page", "fa-angle-right", page + 1, page >= pageCount)}
                {btn("Last page", "fa-angle-double-right", pageCount, page >= pageCount)}
            </div>
        </div>
    );
}
